export default "__VITE_ASSET__mbKvlPE4__"